import type { TemptrashContract } from './contract.js';
import { TEMPTRASH_NO_INPUT } from './contract.js';
import { createInitialState, deserialize, migrateSave, serialize } from './sim/state.js';
import { step } from './sim/step.js';
import { getViewModel } from './sim/view-model.js';

export * from './contract.js';
export { createInitialState, deserialize, getViewModel, migrateSave, serialize, step };

export const NO_INPUT = TEMPTRASH_NO_INPUT;

export const temptrashContract: TemptrashContract = {
  createInitialState,
  step,
  getViewModel,
  serialize,
  deserialize,
  migrateSave,
};
